
















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import { ChainModule } from '@/store/modules/chain.module'
import Confirm from '@/components/Confirm.vue'
import Sortable from '@/directives/sortable'
import UpdateDescriptionModal from './UpdateDescriptionModal.vue'
import { mileStoneDescriptionActions } from '../helpers/milestone'
import { VPopover } from 'v-tooltip'
import EditAddMilestone from './EditAddMilestone.vue'
import AddEditTemplateModal from './AddEditTemplateModal.vue'
import { MilestoneTemplate, MilestoneDescriptions } from '@/store/types/milestone'
@Component({
  directives: {
    sortable: new Sortable()
  },
  components: {
    Icon,
    EditAddMilestone,
    Confirm,
    UpdateDescriptionModal,
    VPopover,
    AddEditTemplateModal
  },
  methods: {
    mileStoneDescriptionActions
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'chain'
    }
  }
})
export default class MilestonesBlock extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  mileStoneDescriptionActions = mileStoneDescriptionActions
  newMilestoneName: string = ''
  editableMilestoneName: string = ''
  isWantCreateMilestone: boolean = false
  editableTemplate: number | null = null
  deletableTemplate: { type: 'Milestone' | 'Template', id: number } | null = null
  isVisible: boolean = true
  isBlocked: boolean = false
  isWantUpdateDescription: boolean = false
  updateDescriptionTemplate: MilestoneTemplate | null = null
  descriptionsOfSubMilestones: MilestoneDescriptions[] = this.$props.item.subTemplates.map((subTemplate: MilestoneTemplate) => {
    return {
      id: subTemplate.id,
      show: false,
      description: subTemplate.description
    }
  })

  toggleVisibility () {
    this.isVisible = !this.isVisible
  }

  goEditTemplateMode (template: MilestoneTemplate) {
    this.editableTemplate = template.id
    this.editableMilestoneName = template.milestone
  }

  goEditDescription (template: MilestoneTemplate) {
    this.isWantUpdateDescription = true
    this.updateDescriptionTemplate = template
  }

  async updateTemplateDescription (templateDescription: { id: number, description: string }) {
    if (this.isBlocked) {
      return
    }
    this.isBlocked = true
    if (this.$props.type === 'chain') {
      await this.chainModuleInstance.editOnboardingTemplate({
        id: (this.updateDescriptionTemplate as MilestoneTemplate).id,
        data: {
          description: templateDescription.description
        }
      })
    } else if (this.$props.type === 'user') {
      await this.chainModuleInstance.editTrainingTemplate({
        id: (this.updateDescriptionTemplate as MilestoneTemplate).id,
        data: {
          description: templateDescription.description
        }
      })
    }
    setTimeout(() => {
      this.isBlocked = false
    }, 1000)
    this.isWantUpdateDescription = false
    this.updateDescriptionTemplate = null
    const description = this.descriptionsOfSubMilestones.find((description: MilestoneDescriptions) => description.id === templateDescription.id)
    if (description) {
      description.description = templateDescription.description
    }
  }

  async deleteTemplate () {
    try {
      const id = (this.deletableTemplate as { type: 'Milestone' | 'Template', id: number }).id
      if (this.$props.type === 'chain') {
        await this.chainModuleInstance.deleteOnboardingTemplate(id)
      } else if (this.$props.type === 'user') {
        await this.chainModuleInstance.deleteTrainingTemplate(id)
      }
    } finally {
      this.deletableTemplate = null
    }
  }

  async editMilestone (editableMilestoneName: string) {
    if (this.isBlocked) {
      return
    }
    this.isBlocked = true
    if (this.$props.type === 'chain') {
      await this.chainModuleInstance.editOnboardingTemplate({
        id: this.editableTemplate as number,
        data: {
          milestone: editableMilestoneName
        }
      })
    } else if (this.$props.type === 'user') {
      await this.chainModuleInstance.editTrainingTemplate({
        id: this.editableTemplate as number,
        data: {
          milestone: editableMilestoneName
        }
      })
    }
    this.editableTemplate = null
    setTimeout(() => {
      this.isBlocked = false
    }, 1000)
  }

  async swapMilestones (event: any) {
    const { newIndex, oldIndex } = event
    const templates = this.$props.item.subTemplates

    if (newIndex > oldIndex) {
      for (let i = oldIndex; i < newIndex; i++) {
        const idx = i
        // @ts-ignore
        templates[idx].order = templates[idx].order - 1
      }
    } else {
      for (let i = newIndex; i < oldIndex + 1; i++) {
        // @ts-ignore
        templates[i].order = templates[i].order + 1
      }
    }
    if (this.$props.type === 'chain') {
      await this.chainModuleInstance.saveOnboardingTemplatesOrder(templates)
    } else if (this.$props.type === 'user') {
      await this.chainModuleInstance.saveTrainingTemplatesOrder(templates)
    }
  }

  async createMilestone (newMilestoneName: string) {
    if (this.isBlocked) {
      return
    }
    this.isBlocked = true
    if (this.$props.type === 'chain') {
      await this.chainModuleInstance.createOnboardingTemplate({
        name: newMilestoneName,
        parent: this.$props.item.parent.id
      })
    } else if (this.$props.type === 'user') {
      await this.chainModuleInstance.createTrainingTemplate({
        name: newMilestoneName,
        parent: this.$props.item.parent.id
      })
    }
    this.isWantCreateMilestone = false
    setTimeout(() => {
      this.isBlocked = false
    }, 1000)
  }
}
